import { useDispatch, useSelector, useStore } from 'react-redux';
import type { AppDispatch, RootState, AppStore } from './index';

/**
 * Typed `useDispatch` hook for the app
 * Use this instead of plain `useDispatch` for proper typing
 */
export const useAppDispatch = useDispatch.withTypes<AppDispatch>();

/**
 * Typed `useSelector` hook for the app
 * Use this instead of plain `useSelector` for proper typing
 *
 * @example
 * ```typescript
 * const sidebarExpanded = useAppSelector((state) => state.ui.sidebarExpanded);
 * const activeTenantId = useAppSelector(selectActiveTenantId);
 * ```
 */
export const useAppSelector = useSelector.withTypes<RootState>();

// Re-export for convenience (defined in store/api/baseQuery)
export { selectActiveTenantId } from './api/baseQuery';

/**
 * Typed `useStore` hook for the app
 * Use this when you need direct access to the store instance
 */
export const useAppStore = useStore.withTypes<AppStore>();


